import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'


import image2 from '../images/salon.jpg'
import image5 from '../images/terrasse1.jpg'
import image10 from '../images/cuisine2.jpeg'

import './features25.css'

const Features25 = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(0)
  return (
    <div className="thq-section-padding">
      <div className="features25-container2 thq-section-max-width">
        <div className="features25-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features25-tab-horizontal1"
          >
            <div className="features25-divider-container1">
              {activeTab === 0 && <div className="features25-container3"></div>}
            </div>
            <div className="features25-content1">
              <h2 className="thq-heading-2">
                <span className="features25-text6">{t('features25.title1')}</span>
              </h2>
              <span className="thq-body-small">
                <span className="features25-text3">{t('features25.desc1')}</span>
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features25-tab-horizontal2"
          >
            <div className="features25-divider-container2">
              {activeTab === 1 && <div className="features25-container4"></div>}
            </div>
            <div className="features25-content2">
              <h2 className="thq-heading-2">
                <span className="features25-text1">{t('features25.title2')}</span>
              </h2>
              <span className="thq-body-small">
                <span className="features25-text4">{t('features25.desc2')}</span>
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features25-tab-horizontal3"
          >
            <div className="features25-divider-container3">
              {activeTab === 2 && <div className="features25-container5"></div>}
            </div>
            <div className="features25-content3">
              <h2 className="thq-heading-2">
                <span className="features25-text2">{t('features25.title3')}</span>
              </h2>
              <span className="thq-body-small">
                <span className="features25-text5">{t('features25.desc3')}</span>
              </span>
            </div>
          </div>
        </div>
        <div className="features25-image-container">
          {activeTab === 0 && (
            <img
              alt={t('features25.alt1')}
              src={image10}
              className="features25-image1 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 1 && (
            <img
              alt={t('features25.alt2')}
              src={image2}
              className="features25-image2 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={t('features25.alt3')}
              src={image5}
              className="features25-image3 thq-img-ratio-16-9"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Features25
